/* eslint-disable @typescript-eslint/naming-convention */
export enum timeScalesEnum {
    hourly = 'hourly',
    daily = 'daily',
    weekly = 'weekly',
    monthly = 'monthly',
    quarterly = 'quarterly',
    yearly = 'yearly',
    other = 'other'
}
